import React from "react";
import { Card, Status, FormSelect, Button, Loader } from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSave } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

import ModalEditFolder from "../home/ModalEditFolder";
import axiosConfig from "../../utils/axiosConfig";

import { getStatus, getCompanyName } from "../../utils/general";

export default class Folder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalEditFolder: false,
      isLoadExpert: false,
      experts: [],
      expertId: "",
    };
  }

  componentDidMount() {
    this.syncExpertId();
    this.getExperts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.appointmentExpertId !== this.props.appointmentExpertId) {
      this.syncExpertId();
    }
  }

  syncExpertId = () => {
    this.setState({
      expertId: this.props.appointmentExpertId
        ? this.props.appointmentExpertId.toString()
        : "",
    });
  };

  getExperts = () => {
    axiosConfig("folder/get-folder-owners")
      .then((res) => {
        if (res.data.success) {
          this.setState({ experts: res.data.owners });
        }
      })
      .catch(() => {});
  };

  updateExpert = () => {
    this.setState({ isLoadExpert: true }, () => {
      axiosConfig("folder/update-folder-owner", {
        data: {
          id: this.props.id,
          ownerId: this.state.expertId,
        },
      })
        .then((res) => {
          this.setState({ isLoadExpert: false }, () => {
            if (res.data.success) {
              alert("L'expert du dossier a été modifié");
              this.props.getFolder();
            } else {
              alert(
                res.data.message ||
                  "Une erreur est survenue, veuillez réessayer"
              );
              this.syncExpertId();
            }
          });
        })
        .catch(() =>
          this.setState({ isLoadExpert: false }, () =>
            alert("Une erreur est survenue, veuillez réessayer")
          )
        );
    });
  };

  // A legacy RDV expert may be a non-expert (a director who created the folder):
  // keep them selectable so the field still shows who holds it.
  getExpertOptions = () => {
    const options = this.state.experts.map((expert) => ({
      value: expert.id.toString(),
      text: expert.agencyName
        ? `${expert.name} (${expert.agencyName})`
        : expert.name,
    }));
    const { appointmentExpertId, appointmentExpertName } = this.props;
    if (
      appointmentExpertId &&
      appointmentExpertName &&
      !options.some(
        (option) => option.value === appointmentExpertId.toString()
      )
    ) {
      options.unshift({
        value: appointmentExpertId.toString(),
        text: appointmentExpertName,
      });
    }
    return options;
  };

  render() {
    return (
      <Row>
        <Col xs={12} md={6} className="mb-10">
          <Card
            title="Informations"
            action={
              this.props.status < 4 ? <FontAwesomeIcon icon={faPen} /> : <></>
            }
            onClick={() => this.setState({ isModalEditFolder: true })}
          >
            <Row>
              <Col xs={12} md={6} className="mb-10">
                <Status text={getStatus(this.props.status)} />
              </Col>
              <Col xs={12} md={6} lg={8}></Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  N° dossier : <b>{this.props.reference}</b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Compagnie : <b>{getCompanyName(this.props.company)}</b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Marque : <b>{this.props.brand}</b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Modèle : <b>{this.props.model}</b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Immatriculation : <b>{this.props.licensePlate}</b>
                </p>
              </Col>

              <Col xs={12} className="mb-10">
                <p className="m-0">
                  RDV :{" "}
                  <b>
                    {moment(this.props.dateAppointment).format("DD/MM/YYYY")}{" "}
                    {this.props.hourAppointment}
                  </b>
                  {this.props.appointmentCanceled ? (
                    <span style={{ color: "#6b6b6b" }}> (annulé)</span>
                  ) : null}
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={12} md={6} className="mb-10">
          <Card
            className="h-100"
            title="Agence"
            action={
              this.props.status < 4 ? <FontAwesomeIcon icon={faPen} /> : <></>
            }
            onClick={() => this.setState({ isModalEditFolder: true })}
          >
            <Row>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Nom : <b>{this.props.agencyName}</b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  E-mail : <b>{this.props.agencyEmail}</b>
                </p>
              </Col>
              <Col xs={12} className="mb-10">
                <FormSelect
                  title="Expert"
                  value={this.state.expertId}
                  name="expertId"
                  init="Sélectionner un expert"
                  options={this.getExpertOptions()}
                  onChange={(e) => this.setState({ expertId: e.target.value })}
                />
                <Button
                  className="mt-10"
                  text="Changer l'expert"
                  disabled={
                    !this.state.expertId ||
                    this.state.expertId ===
                      (this.props.appointmentExpertId
                        ? this.props.appointmentExpertId.toString()
                        : "")
                  }
                  onClick={this.updateExpert}
                >
                  <FontAwesomeIcon icon={faSave} />
                </Button>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Créé par : <b>{this.props.ownerName}</b>
                </p>
              </Col>
            </Row>
            <Loader show={this.state.isLoadExpert} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card
            className="h-100"
            title="Réparateur "
            action={
              this.props.status < 4 ? <FontAwesomeIcon icon={faPen} /> : <></>
            }
            onClick={() => this.setState({ isModalEditFolder: true })}
          >
            <Row>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Nom : <b>{this.props.repairerName}</b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Téléphone : <b>{this.props.repairerPhone}</b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  E-mail : <b>{this.props.repairerEmail}</b>
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card
            title="Assuré"
            action={
              this.props.status < 4 ? <FontAwesomeIcon icon={faPen} /> : <></>
            }
            onClick={() => this.setState({ isModalEditFolder: true })}
          >
            <Row>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Client :{" "}
                  <b>
                    {this.props.kind} {this.props.insuredName}
                  </b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  E-mail : <b>{this.props.insuredEmail}</b>
                </p>
              </Col>
              <Col xs={12} md={6} className="mb-10">
                <p className="m-0">
                  Téléphone : <b>{this.props.insuredPhone}</b>
                </p>
              </Col>
            </Row>
          </Card>
        </Col>

        <ModalEditFolder
          onClose={(isReload) => {
            if (isReload) {
              this.props.getFolder();
            }
            this.setState({ isModalEditFolder: false });
          }}
          show={this.state.isModalEditFolder}
          folder={{
            id: this.props.id,
            reference: this.props.reference,
            agencyEmail: this.props.agencyEmail,
            licensePlate: this.props.licensePlate,
            brand: this.props.brand,
            model: this.props.model,
            kind: this.props.kind,
            insuredName: this.props.insuredName,
            insuredPhone: this.props.insuredPhone,
            insuredEmail: this.props.insuredEmail,
            repairerName: this.props.repairerName,
            repairerPhone: this.props.repairerPhone,
            repairerEmail: this.props.repairerEmail,
            company: this.props.company,
            dateAppointment: this.props.dateAppointment,
            hourAppointment: this.props.hourAppointment,
          }}
        />
      </Row>
    );
  }
}
